import { render, staticRenderFns } from "./CustomResourceDefinition.vue?vue&type=template&id=5d58fa7e&"
import script from "./CustomResourceDefinition.vue?vue&type=script&lang=js&"
export * from "./CustomResourceDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports